<script>
    import { metaInfo } from "@/core/MetaInfo";
    import PromocodeBanner from "@xd/components/PromocodeBanner";
    import PromocodeList from "@xd/components/PromocodeList";
    import PromocodeHelp from "@xd/components/PromocodeHelp";
    // import PromocodeSocial from "@xd/components/PromocodeSocial";
    // import PromocodeVideoMoc from "@xd/components/PromocodeVideoMoc";
    import PromocodeEmail from "@xd/components/PromocodeEmail";
    import PromocodeSteps from "@xd/components/PromocodeSteps";

    export default {
        name: "Promocode",
        components: {
            PromocodeSteps,
            PromocodeEmail,
            // PromocodeVideoMoc,
            // PromocodeSocial,
            PromocodeHelp,
            PromocodeList,
            PromocodeBanner,
        },
        metaInfo() {
            return metaInfo.getMeta("promocode");
        },
    };
</script>

<template>
    <div class="promocode">
        <div class="l-container">
            <promocode-banner></promocode-banner>
            <promocode-list></promocode-list>
            <promocode-steps></promocode-steps>
            <promocode-help></promocode-help>
            <!--            <promocode-social></promocode-social>-->
            <!--            <promocode-video-moc></promocode-video-moc>-->
        </div>
        <promocode-email></promocode-email>
    </div>
</template>

<style lang="scss">
    .promocode {
        overflow: hidden;
    }

    .promocode__title {
        font-weight: bold;
        font-size: 30px;
        line-height: 34px;
        color: var(--primary-text);

        @include bp($bp-desktop-sm) {
            font-weight: 900;
            font-size: 40px;
            line-height: 48px;
        }

        span {
            color: var(--secondary--light);
        }
    }
</style>
